import { useMemo } from 'react';

import { PractitionerMedicalServiceSimple } from '@dreryk/egabinet-private-medical-service-frontend-api';
import { Money } from '@dreryk/money-common-api';

import { PriceText } from '../../../shared/components/PriceText';

type MedicalServicePriceCellProps = {
   readonly medicalServiceDefaultPrice: Money;
   readonly medicalServicePractitioners: PractitionerMedicalServiceSimple[];
};

export const MedicalServicePriceCell = (props: MedicalServicePriceCellProps): JSX.Element => {
   const [minPrice, maxPrice] = useMemo(() => {
      const allPrices = props.medicalServicePractitioners.map(
         (practitioner) => practitioner.individualPrice?.asNumber() ?? props.medicalServiceDefaultPrice.asNumber()
      );

      return [Money.of(Math.min(...allPrices)), Money.of(Math.max(...allPrices))];
   }, [props.medicalServicePractitioners, props.medicalServiceDefaultPrice]);

   return <PriceText testId={'price'} min={minPrice} max={maxPrice} />;
};
